<modulo posicao="atendimento-personalizado"></modulo>
<footer>
      <div class="linha" style="margin-top: 0;"></div>
      <div class="content">
          <div class="container">
              <div class="row">
                  <div class="col-md-3">
                    <modulo posicao="rede-social"></modulo>   
                  </div>
                  <div class="col-md-3">   
                    <menu-attendance class="module-item"></menu-attendance>
                  </div>   
                  <div class="col-md-3"> 
                    <menu-services class="module-item"></menu-services>
                  </div> 
                  <div class="col-md-3">  
                    <modulo posicao="contato" class="module-item"></modulo>
                  </div>    
              </div>  
          </div> 
      </div>
      <div class="linha" style="margin-bottom: 0;"></div>   
      <copyright></copyright>
</footer>    